const initialState = {
  loading: false,
  data: [], // for franchises
  builders: [], // for franchise builders
  total: 0,
  error: null,

  franchiseCatalogues: [], // stores catalogue list data
  franchiseCatalogueTotal: 0, // total count for pagination
  franchiseCatalogueLoading: false,
  franchiseCatalogueError: null,

  projectCatalogueExcel: null, // data from viewExcel API
  projectCatalogueLoading: false, // optional fine loading state for viewExcel
  projectCatalogueError: null,

  // Project related state
  projects: [],
  project: null,
  project_catalogue: null,
  projectVR: null,
  priceList: null,
  priceListUpdate: null,
  projectTotal: 0,
  projectError: null,

  // Selected IDs and names for navigation state replacement
  selectedBuilderId: null,
  selectedFranchiseId: null,
  selectedProjectId: null,
  selectedProjectName: null,
};

const SET_SELECTION = "SET_SELECTION";
const CLEAR_SELECTION = "CLEAR_SELECTION";

export const franchiseReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_FRANCHISE_CATALOGUE_LIST_REQUEST":
      return {
        ...state,
        franchiseCatalogueLoading: true,
        franchiseCatalogues: [],
        franchiseCatalogueError: null,
      };
    case "GET_FRANCHISE_CATALOGUE_LIST_SUCCESS":
      return {
        ...state,
        franchiseCatalogueLoading: false,
        franchiseCatalogues: action.payload.data || [],
        franchiseCatalogueTotal: action.payload.total || 0,
        franchiseCatalogueError: null,
      };
    case "GET_FRANCHISE_CATALOGUE_LIST_FAILED":
      return {
        ...state,
        franchiseCatalogueLoading: false,
        franchiseCatalogueError: action.payload,
        franchiseCatalogues: [],
      };

    // Franchise cases
    case "GET_BUILDERS_BY_FRANCHISE_REQUEST":
      return {
        ...state,
        loading: true,
        builders: [],
        error: null,
      };
    case "GET_BUILDERS_BY_FRANCHISE_SUCCESS":
      return {
        ...state,
        loading: false,
        builders: action.payload.data || [],
        total: action.payload.total || 0,
        error: null,
      };
    case "GET_BUILDERS_BY_FRANCHISE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        builders: [],
      };
    case "GET_FRANCHISE_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        data: [],
        error: null,
      };
    case "GET_FRANCHISE_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload.data.data || [],
        total: action.payload.data.total || 0,
        error: null,
      };
    case "GET_FRANCHISE_LIST_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        data: [],
      };
    case "GET_FRANCHISE_REQUEST":
      return {
        ...state,
        loading: true,
        franchise: null,
        error: null,
      };
    case "GET_FRANCHISE_SUCCESS":
      return {
        ...state,
        loading: false,
        franchise: action.payload,
        error: null,
      };
    case "GET_FRANCHISE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "VIEW_EXCEL_REQUEST":
      return {
        ...state,
        projectCatalogueLoading: true,
        projectCatalogueError: null,
      };
    case "VIEW_EXCEL_SUCCESS":
      return {
        ...state,
        projectCatalogueLoading: false,
        projectCatalogueExcel: action.payload,
        projectCatalogueError: null,
      };
    case "VIEW_EXCEL_FAIL":
      return {
        ...state,
        projectCatalogueLoading: false,
        projectCatalogueError: action.payload,
        projectCatalogueExcel: null,
      };

    // Project cases
    case "GET_PROJECTS_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        projects: [],
        projectError: null,
      };
    case "GET_PROJECTS_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        projects: Array.isArray(action.payload.data) ? action.payload.data : [],
        projectTotal: action.payload.total || 0,
        projectError: null,
      };
    case "GET_PROJECTS_LIST_FAILED":
      return {
        ...state,
        loading: false,
        projects: [],
        projectError: action.payload,
      };
    case "EDIT_PROJECT_REQUEST":
      return {
        ...state,
        loading: true,
        projectError: null,
      };
    case "EDIT_PROJECT_SUCCESS":
      return {
        ...state,
        loading: false,
        projects: action.payload.data || state.projects,
        projectError: null,
      };
    case "EDIT_PROJECT_FAILED":
      return {
        ...state,
        loading: false,
        projectError: action.payload,
      };
    case "GET_PROJECT_REQUEST":
      return {
        ...state,
        loading: true,
        project: null,
        projectError: null,
      };
    case "GET_PROJECT_SUCCESS":
      return {
        ...state,
        loading: false,
        project: action.payload,
        projectError: null,
      };
    case "GET_PROJECT_FAILED":
      return {
        ...state,
        loading: false,
        projectError: action.payload,
      };
    case "GET_PROJECT_CATALOGUE_REQUEST":
      return {
        ...state,
        loading: true,
        project_catalogue: null,
        projectError: null,
      };
    case "GET_PROJECT_CATALOGUE_SUCCESS":
      return {
        ...state,
        loading: false,
        project_catalogue: action.payload,
        projectError: null,
      };
    case "GET_PROJECT_CATALOGUE_FAILED":
      return {
        ...state,
        loading: false,
        projectError: action.payload,
      };
    case "ADD_VR_REQUEST":
      return {
        ...state,
        loading: true,
        projectVR: null,
        projectError: null,
      };
    case "ADD_VR_SUCCESS":
      return {
        ...state,
        loading: false,
        projectVR: action.payload,
        projectError: null,
      };
    case "ADD_VR_FAILED":
      return {
        ...state,
        loading: false,
        projectError: action.payload,
      };
    case "SHOW_PRICELIST_REQUEST":
      return { ...state, loading: true, projectError: null };
    case "SHOW_PRICELIST_SUCCESS":
      return {
        ...state,
        loading: false,
        priceList: action.payload,
        projectError: null,
      };
    case "SHOW_PRICELIST_FAILED":
      return { ...state, loading: false, projectError: action.payload };
    case "UPDATE_PRICELIST_REQUEST":
      return { ...state, loading: true, projectError: null };
    case "UPDATE_PRICELIST_SUCCESS":
      return {
        ...state,
        loading: false,
        priceListUpdate: action.payload,
        projectError: null,
      };
    case "UPDATE_PRICELIST_FAILURE":
      return { ...state, loading: false, projectError: action.payload };

    // New selection handlers
    case SET_SELECTION:
      return {
        ...state,
        selectedBuilderId: action.payload.builderId || null,
        selectedFranchiseId: action.payload.franchiseId || null,
        selectedProjectId: action.payload.projectId || null,
        selectedProjectName: action.payload.projectName || null,
      };

      case "REVOKE_CATALOGUE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "REVOKE_CATALOGUE_SUCCESS":
      return {
        ...state,
        loading: false,
        // Optionally update franchiseCatalogues if needed, e.g., remove revoked catalogue
        franchiseCatalogues: state.franchiseCatalogues.filter(
          (item) => item._id !== action.payload.data?._id
        ),
        error: null,
      };
    case "REVOKE_CATALOGUE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Revoke Builder Project cases
    case "REVOKE_BUILDER_PROJECT_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "REVOKE_BUILDER_PROJECT_SUCCESS":
      return {
        ...state,
        loading: false,
        // Optionally update builders or projects if needed here
        error: null,
      };
    case "REVOKE_BUILDER_PROJECT_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Account Status Update cases
    case "UPDATE_ACCOUNT_STATUS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "UPDATE_ACCOUNT_STATUS_SUCCESS":
      return {
        ...state,
        loading: false,
        // Optionally update the specific franchise's account_status in data list or details
        data: state.data.map((franchise) =>
          franchise._id === action.payload.data._id
            ? { ...franchise, account_status: action.payload.data.account_status }
            : franchise
        ),
        error: null,
      };
    case "UPDATE_ACCOUNT_STATUS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_SELECTION:
      return {
        ...state,
        selectedBuilderId: null,
        selectedFranchiseId: null,
        selectedProjectId: null,
        selectedProjectName: null,
      };

    default:
      return state;
  }
};

// Action creators to use in your components or thunk actions
export const setSelection = ({
  builderId,
  franchiseId,
  projectId,
  projectName,
}) => ({
  type: SET_SELECTION,
  payload: { builderId, franchiseId, projectId, projectName },
});

export const clearSelection = () => ({
  type: CLEAR_SELECTION,
});
